var map = {
	"./arrow-down.svg": 190,
	"./arrow-right.svg": 142,
	"./bg-1.jpg": 859,
	"./bg-1.webp": 94,
	"./bg-2.jpg": 37,
	"./bg-2.webp": 701,
	"./bg-3.jpg": 407,
	"./bg-3.webp": 19,
	"./bg-4.jpg": 693,
	"./bg-4.webp": 272,
	"./createproject-bg.jpg": 711,
	"./createproject-bg.webp": 39,
	"./email.svg": 283,
	"./github.svg": 926,
	"./habits-bg.jpg": 950,
	"./habits-bg.webp": 664,
	"./kalorientracker-bg.jpg": 804,
	"./kalorientracker-bg.webp": 854,
	"./madmaths-bg.jpg": 880,
	"./madmaths-bg.webp": 921,
	"./memory-bg.png": 451,
	"./memory-bg.webp": 88,
	"./pathfinder-bg.png": 346,
	"./pathfinder-bg.webp": 441,
	"./plate-atlas-bg.webp": 629,
	"./pong-bg.png": 189,
	"./pong-bg.webp": 740,
	"./snapper-bg.png": 671,
	"./snapper-bg.webp": 751,
	"./sorting-visualizer-bg.png": 330,
	"./sorting-visualizer-bg.webp": 744,
	"./voidcut-bg.png": 410,
	"./voidcut-bg.webp": 581,
	"./wordocean-bg.png": 660,
	"./wordocean-bg.webp": 657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;